import React from 'react';
import Testimonial, {TestimonialProps} from './Testimonial';
import {FieldArray} from 'formik';
import Button from 'src/components/button';
import styles from 'src/views/admin/TimeSensitiveItemTypes/Details/Details.module.scss';

const initialTestimonialValues = {
  _id: null,
  name: null,
  avatarUrl: '',
  imageUrl: '',
  text: '',
};

interface TestimonialsProps {
  testimonials: TestimonialProps[];
}

const Testimonials = (props: TestimonialsProps): React.ReactElement => {
  const {testimonials} = props;
  return (
    <div className={styles.detailsSectionBorder}>
      <h3>Testimonials</h3>
      <FieldArray
        name="testimonials"
        render={(arrayHelpers): React.ReactElement => (
          <div>
            {testimonials &&
              testimonials.length > 0 &&
              testimonials.map((testimonial, index) => (
                <Testimonial
                  testimonial={testimonial}
                  key={index}
                  index={index}
                  removeTestimonial={(): (<T>(index: number) => T | undefined) =>
                    arrayHelpers.remove
                  }
                />
              ))}
            <Button
              aria-label="Add testimonial"
              size="small"
              className={styles.addField}
              onClick={(): void => arrayHelpers.push(initialTestimonialValues)}
            >
              + Additional testimonial
            </Button>
          </div>
        )}
      />
    </div>
  );
};

export default Testimonials;
